import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { upscuser } from "../../components/Service/upscenquiry";
import { useState } from "react";
import dynamic from 'next/dynamic';
const Otpverification = dynamic(()=>import("../../components/Modal/Otpverification"));
const Classroom_form = (props) => {

  const [verified, setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);

  function convertJsonStringToNumber(jsonString) {
    // Parse the JSON string to an object
    const jsonObject = JSON.parse(jsonString);
  
    // Iterate over the keys and convert numeric strings to numbers
    for (const key in jsonObject) {
      if (jsonObject.hasOwnProperty(key)
&& !isNaN(jsonObject[key])) {
        jsonObject[key] = Number(jsonObject[key]);
      }
    }
  
    return jsonObject;
  }
  function onChange(value) {
    if (value == null) {
      setverified(false);
    }
    else {
      setverified(true);
    }
  }
 
  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};
      formData['formType'] = "UPSCsiamentoring";
      formData['title'] = "UPSC Classroom & Online";
      formData['branch'] = props.branchname;
      Array.from(e.currentTarget.elements).forEach(field => {
        if (!field.name) return;
        formData[field.name] = field.value;

        
      });
      //formData['countryCode'] = "+91";
      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
      const transform={fields:{...formData}};
      console.log(transform);

       setIsLoading(true);
       upscuser(transform)
           .then(response => {
              
               setModalOtp(true);
               setmodalOtpstatus(response.message);
               window.grecaptcha.reset(setverified);
               setverified(false);
               setvaluephno(undefined);
               document.getElementById("UPSCsiamentoring").reset();
               setIsLoading(false);
           })
           .catch(error => {
            setModalOtp(true);
            setmodalOtpstatus("failure");
            window.grecaptcha.reset(setverified);
            setverified(false);
            setIsLoading(false);
          })
      
    //   createUser(formData)
    //     .then(response => {
    //       setModalOtp(true);
    //       setmodalOtpstatus(response.message);
    //       if(formData['branch']=='Annanagar')
    //         {
    //           PostGooglesheet(formData);
    //         } 
    //       window.grecaptcha.reset(setverified);
    //       setverified(false);
    //       setvaluephno(undefined);
    //       document.getElementById("upscclassroomform").reset();
    //       setIsLoading(false);
    //     })
    //     .catch(error => {
    //       setModalOtp(true);
    //       setmodalOtpstatus("failure");
    //       window.grecaptcha.reset(setverified);
    //       setverified(false);
    //       setIsLoading(false);
    //     })

     }
    else {
      setcaptchaerror(true);
      setTimeout(() => {
        setcaptchaerror(false);
      }, 3000);
    }
  }
  return (
    <>

      {isLoading &&
        <div class="APIPreLoader" id="APIPreLoader">
          <div class="loader">Loading...</div>
        </div>
      }
      <Otpverification show={modalOtp} title={modalOtpstatus} frompage="UPSCsiamentoring" onHide={() => setModalOtp(false)} />

      <div className="">
        <div className="row mx-auto pt-3" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>
          <div className="container pt-4">
            <div className="row">
              
              <p className={`${styles.acheiverrank} text-center mb-0`}> Students Mentoring Online Support </p>
            </div>

            <div className="row">
              <div className="col-md-8 col-12 mx-auto">
                <form onSubmit={handleOnSubmit} id="UPSCsiamentoring" autoComplete="off">
                  <div className="row pt-4">

                    <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        {/* <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Name<span className={`${styles.formstar}`}>*</span></label></p> */}
                        <input type="text" className={`${styles.acheiverrank} form-control`} placeholder="Name" autoComplete="off" name="name" minLength="1" required />
                      </div>
                    </div>

                    <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        {/* <p className="text-start mb-0"><label htmlFor="exampleInputmail" className={`${styles.acheiverrank} form-label`}>Email Address<span className={`${styles.formstar}`}>*</span></label></p> */}
                        <input type="email" className={`${styles.acheiverrank} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                      </div>
                    </div>

                    <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                      </div>
                    </div>

                    <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        {/* <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Name<span className={`${styles.formstar}`}>*</span></label></p> */}
                        <input type="text" className={`${styles.acheiverrank} form-control`} placeholder="Unique ID" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" autoComplete="off" name="uniqid" minLength="1" required />
                      </div>
                    </div>

                  
                      <div className="col-12 col-lg-3">
                      <div className="mb-4">
                        {/* <p className="text-start mb-0" style={{marginTop: "-2%"}}><label htmlFor="exampleInputMessage*" className={`${styles.acheiverrank} form-label`}>Query<span className={`${styles.formstar}`}>*</span></label></p> */}
                        <input type="text" className={`${styles.acheiverrank} form-control`} placeholder="Batch Name" title="Please describe your query in detail" autoComplete="off" name="BatchName" required></input>
                      </div>
                    </div>
                    
                     <div className="col-12 col-xl-3 col-lg-6 ">
                                        <div className="mb-4">
                                        <select className={`${styles.acheiverrank} form-select form-control`} name="centers" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Select Centers</option>
                                            <option value="Chennai-Annanagar">Annanagar</option>
                                            <option value="Chennai-Annanagar">Adyar</option>
                                            <option value="Delhi">Delhi</option>
                                            <option value="Bengaluru">Bengaluru</option>
                                            <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                                            <option value="Hyderabad">Hyderabad</option>
                                            <option value="Hyderabad">Trichy</option>
                                            <option value="Salem">Salem</option>
                                            <option value="Salem">Madurai</option>
                                            <option value="Salem">Coimbatore</option>
                                            <option value="Online">Online</option>
                                         </select>
                                        </div>
                                        </div>
  <div className="col-12 col-xl-3 col-lg-6 ">
                                        <div className="mb-4">
                                        <select className={`${styles.acheiverrank} form-select form-control`} name="SlotPreferenes" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Slot Preferenes</option>
                                            <option value="Morning(10am - 12pm)">Morning(10am - 12pm)</option>
                                            <option value="Afternoon(2pm to 4pm)">Afternoon(2pm to 4pm)</option>
                                            <option value="Evening(5pm - 7pm)">Evening(5pm - 7pm)</option>
                                           
                                         </select>
                                        </div>
                                        </div>
                    <div className="col-12 col-lg-3">
                      
                      <div className="d-flex flex-wrap mb-3">
                        <div className="me-3 mt-2">
                          <ReCAPTCHA className={`${styles.captcha}`}
                            sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                            onChange={onChange}
                          />
                          <div className="">
                            {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-3 offset-lg-10">
                      <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
export async function PostGooglesheet(formData){
 
  delete formData.countryCode;
  delete formData['g-recaptcha-response'];
  delete formData.formType;
  console.log(formData);
  if(formData)
  {
    console.log(formData);
  try {
    const response = await fetch('/api/googlesheets', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
                'Content-Type': 'application/json'
      },
      body: JSON.stringify( formData ),
    })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    })
   
  } catch (error) {
    console.error('Error submitting form data to Google Sheets:', error);
  }
}
else
{
  console.log('data emty');
}
}
export default Classroom_form;